exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-client-survey-secondarynav-survey-secondary-nav-style__link {\n  color: var(--cps-color-vibrant-ocean) !important;\n}\n\n.src-client-survey-secondarynav-survey-secondary-nav-style__link:hover {\n  color: var(--cps-color-vibrant-ocean) !important;\n  cursor: pointer !important;\n}\n\n.src-client-survey-secondarynav-survey-secondary-nav-style__leftLi {\n  margin-top: -2px;\n}\n\n.src-client-survey-secondarynav-survey-secondary-nav-style__linkText {\n  font-weight: 400;\n}\n\n.src-client-survey-secondarynav-survey-secondary-nav-style__linkTextBlue {\n  color: var(--cps-color-vibrant-ocean) !important;\n}\n", ""]);

// exports
exports.locals = {
	"link": "src-client-survey-secondarynav-survey-secondary-nav-style__link",
	"leftLi": "src-client-survey-secondarynav-survey-secondary-nav-style__leftLi",
	"linkText": "src-client-survey-secondarynav-survey-secondary-nav-style__linkText",
	"linkTextBlue": "src-client-survey-secondarynav-survey-secondary-nav-style__linkTextBlue"
};